// extracted by mini-css-extract-plugin
module.exports = {"selectionItem":"PurchaseRequest_selectionItem__dNBVB","clickableText":"PurchaseRequest_clickableText__wcwzm","tagBlurred":"PurchaseRequest_tagBlurred__iP_OR"};